import { useState } from 'react'
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import axios from 'axios';
import * as Icon from 'react-bootstrap-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useGetDepartments from '../../Common/ReuseApi/useGetDepartments';
import useGetAllManagers from '../../Common/ReuseApi/useGetAllManagers';



const managerCategoryOptions = [
    { value: 'Project Manager', label: 'Project Manager' },
    { value: 'Product Manager', label: 'Product Manager' },
    { value: 'Program Manager', label: 'Program Manager' },
    { value: 'Technical Manager', label: 'Technical Manager' },
]


const AssignManagerToDepartmentModel = ({ show, close }) => {

    const [managerCategory, setManagerCategory] = useState(null)
    const [managerName, setManagerName] = useState(null)
    const [deptlist, setDeptList] = useState([]);
    const [errState, setErrState] = useState({
        managerCategory: '',
        managerName: '',
        deptlist: ''
    })

    const isNotValidForm = Object.values(errState).some(item => item);

    const handleDeptChange = (selectedOptions) => {
        if (Array.isArray(selectedOptions)) {
            const selectedDept = selectedOptions.map((option) => option.value);
            setDeptList(selectedDept);
        } else {
            setDeptList([selectedOptions.value]);
        }

        setErrState(prev => ({
            ...prev,
            deptlist: '',
        }))
    };

    const resetForm = () => {
        setManagerName(null)
        setManagerCategory(null)
        setDeptList([])
        setErrState({
            managerCategory: '',
            managerName: '',
            deptlist: ''
        })
    }

    const handleAssign = () => {

        // VALIDATE DATA
        const errObj = {
            managerCategory: '',
            managerName: '',
            deptlist: ''
        }

        if (!managerCategory || !managerCategory.value || !managerCategory.label) {
            errObj.managerCategory = 'Manager Category Is Required';
        }

        if (!managerName || !managerName.value || !managerName.label) {
            errObj.managerName = 'Manager Is Required';
        }

        if (!deptlist.length) {
            errObj.deptlist = 'Department Is Required';
        }

        const isNotValid = Object.values(errObj).some(item => item);

        setErrState(errObj)

        if (isNotValid) {
            return;
        }

        const payload = {
            "departmentId": deptlist[0],
            "empId": managerName.value,
            "empName": managerName.label,
        }
        const endpoint = '/department/assignManagerToDept';

        axios.post(process.env.REACT_APP_BASE_URL + endpoint, payload)
        .then((res) => {
            if (res.data.status === 200) {
                toast.success(res.data.msg)
                setTimeout(() => {
                    resetForm();
                    close()
                }, 1000)

            } else {
                toast.error(res.data.msg)
            }
        })
        .catch((err) => {
            console.error("Error", err)
        })
    }


    const { data: allManagerOptions } = useGetAllManagers({
        "designation": managerCategory?.value ?? undefined
    }, [managerCategory]);
    const { allDepartmentOptionsById } = useGetDepartments();

    return (
        <>
            <ToastContainer />
            <Modal show={show} onHide={close} size="lg" centered backdrop='static' keyboard={false}>
                <Modal.Header closeButton className="mngmodelheader">
                    <Modal.Title>
                        <h5>Assign Department </h5>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body size="lg">
                    <Row className='mb-4'>
                        <Col sm={12} md={4}>
                            <Form.Group className="">
                                <Form.Label className="mt-3 fw-bold">
                                    Manager Categories
                                    {/* <span className="requiredfield">*</span> */}
                                </Form.Label>
                                <Select
                                    placeholder="select Manager Category"
                                    isMulti={false}
                                    isSearchable={true}
                                    value={managerCategory}
                                    options={managerCategoryOptions}
                                    onChange={(option) => {
                                        setManagerCategory(option);
                                        setManagerName(null);
                                        setErrState(prev => ({
                                            ...prev,
                                            managerCategory: '',
                                        }))
                                    }}
                                />
                                {
                                    errState.managerCategory && (
                                        <Form.Text className="text-danger">
                                            {errState.managerCategory}
                                        </Form.Text>
                                    )
                                }
                            </Form.Group>
                        </Col>

                        <Col sm={12} md={4}>
                            <Form.Group className="">
                                <Form.Label className="mt-3 fw-bold">
                                    Manager Name
                                    {/* <span className="requiredfield">*</span> */}
                                </Form.Label>
                                <Select
                                    placeholder="select Manager"
                                    isMulti={false}
                                    isSearchable={true}
                                    value={managerName}
                                    options={allManagerOptions}
                                    onChange={(option) => {
                                        setManagerName(option);
                                        setErrState(prev => ({
                                            ...prev,
                                            managerName: '',
                                        }))
                                    }}
                                />
                                {
                                    errState.managerName && (
                                        <Form.Text className="text-danger">
                                            {errState.managerName}
                                        </Form.Text>
                                    )
                                }
                            </Form.Group>
                        </Col>

                        <Col sm={12} md={4}>
                            <Form.Group className="">
                                <Form.Label className="mt-3 fw-bold">
                                    Department
                                    {/* <span className="requiredfield">*</span> */}
                                </Form.Label>
                                <Select
                                    placeholder="Select Department"
                                    isMulti={false}
                                    isSearchable={true}
                                    value={allDepartmentOptionsById.filter((option) => deptlist.includes(option.value))}
                                    options={allDepartmentOptionsById}
                                    onChange={handleDeptChange}
                                />
                                {
                                    errState.deptlist && (
                                        <Form.Text className="text-danger">
                                            {errState.deptlist}
                                        </Form.Text>
                                    )
                                }
                            </Form.Group>
                        </Col>

                    </Row>

                </Modal.Body>

                <Modal.Footer
                    className="text-center mt-4"
                >
                    <Button
                        className={`${isNotValidForm ? 'CancelBtn' : 'primaryBtn'}`}
                        onClick={handleAssign}
                        disabled={isNotValidForm}
                    >
                        <Icon.PersonAdd className='me-2' /> Assign
                    </Button>
                </Modal.Footer>

            </Modal>
        </>

    )
}

export default AssignManagerToDepartmentModel